/*
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka
 * Created: March 3, 2017
 *
 */

import { createSelector } from 'reselect';
import { get, has } from 'lodash';
import { defaultLevels, defaultStandardsOnly, defaultZoomLevel } from 'modules/SearchTerms/const';

const getRawLocation = (state: Object) => get(state, 'routing.locationBeforeTransitions', {
  pathname: '',
  query: null,
});

const getTermFilters = createSelector(
  getRawLocation,
  location => {
    return {
      levels: has(location.query, 'levels') ? location.query.levels : defaultLevels,
      standardsOnly: has(location.query, 'standardsOnly')
        ? location.query.standardsOnly === 'true'
        : defaultStandardsOnly,
      zoomLevel: has(location.query, 'zoomLevel')
      ? parseInt(location.query.zoomLevel, 0)
      : defaultZoomLevel,
    };
  }
);

export {
  getTermFilters,
}